import { Profile } from "./pages/profile";
import { Vault } from "./pages/vault";

import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";

const profilePath = "/participantProfile";
const vaultPath = "/vault";

const profileNav = buildBreadcrumbNavigationConfig("Profile", profilePath);
const vaultNav = buildBreadcrumbNavigationConfig("Vault", vaultPath);

export const profileRoutes = [
  {
    path: profilePath,
    Component: Profile,
    exact: true,
    isPrivate: true,
    navigation: [profileNav],
  },
  {
    path: vaultPath,
    Component: Vault,
    exact: true,
    isPrivate: true,
    navigation: [vaultNav],
  },
];

export const routesLimited = [vaultPath];
